import React from 'react';
import classNames from 'classnames';
import SpinnerDots from '../spinner/dots';
import './styles.scss';

const Follow = (props) => {
    
    const getButtontext = () => {
        if (props.watcherIsSaved && props.watcherExists) {
            return 'Bevakning skapad';
        }

        if (props.watcherIsSaved && !props.watcherExists) {
            return 'Bevakning avslutad';
        }

        if (props.watcherExists) {
            return 'Avsluta bevakning';
        }

        return 'Bevaka enheten';
    }

    return (
        <>
            <button onClick={props.toggleWatcher} className={classNames({
                'follow': true,
                'follow--watcher-exists': props.watcherExists && (!props.watcherIsLoading && !props.watcherIsSaved),
                'follow--watcher-not-exists': !props.watcherExists && (!props.watcherIsLoading && !props.watcherIsSaved),
                'follow--is-loading': props.watcherIsLoading,
                'follow--is-saved': props.watcherIsSaved && props.watcherExists,
                'follow--is-deleted': props.watcherIsSaved && !props.watcherExists,
            })}>
                <span className="follow__bell-deleted"></span>
                <span className="follow__bell-is-deleted"></span>
                <span className="follow__bell-is-saved"></span>
                <span className="follow__bell-saved"></span>
                <span className="follow__text">{getButtontext()}</span>
                <SpinnerDots />
            </button>
        </>
    );
};

export default Follow;